import React from 'react';

export interface ExperienceRecordEvidenceProps {
  entityIds: readonly string[];
  relationshipIds?: readonly string[];
  outcomeTokens?: readonly string[];
  revision: string;
}

/**
 * Exact, non-visual evidence emitted beside records actually rendered by a
 * page. It carries no names or narrative and must never be mounted from shell
 * or URL state alone.
 */
export function ExperienceRecordEvidence({
  entityIds,
  relationshipIds = [],
  outcomeTokens = [],
  revision,
}: ExperienceRecordEvidenceProps) {
  return (
    <span
      className="sr-only"
      data-testid="experience-rendered-record-evidence"
      data-experience-entity-ids={[...new Set(entityIds)].join('|')}
      data-experience-relationship-ids={[...new Set(relationshipIds)].join('|') || undefined}
      data-experience-outcomes={[...new Set(outcomeTokens)].join('|') || undefined}
      data-experience-evidence-revision={revision}
    >
      Rendered record evidence
    </span>
  );
}
